import type { AppetizeSession } from "./appetize";
import type { MediaFile } from "./types";
import axios from "axios";

export async function pushMediaToAppetize(
  session: AppetizeSession,
  mediaFiles: MediaFile[]
): Promise<void> {
  for (const media of mediaFiles) {
    const response = await fetch(media.downloadUrl);
    const blob = await response.blob();
    const file = new File([blob], media.name, { type: blob.type });
    await session.addMedia(file);
  }
}

export async function pushMediaToGateway(
  instanceIp: string,
  sessionId: string,
  mediaFiles: MediaFile[]
): Promise<void> {
  for (const media of mediaFiles) {
    await axios.post(`${instanceIp}/session/${sessionId}/push-media`, {
      download_url: media.downloadUrl,
      file_name: media.name,
    });
  }
}
